import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { ServiceManager } from '@jutro/services';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from 'gw-digital-auth-react';
import { getPageHeaderImage, getBannerImage, getImageSrc } from '../../customer/utils/lobIconUtil';
import metadata from './PageBannerComponent.metadata.json5';
import styles from './PageBannerComponent.module.scss';
import messages from './PageBannerComponent.messages';


function PageBannerComponent(props) {
    const { pageName, pageTitle, lobCode } = props;
    const { env } = appConfig;
    const breakpoint = useContext(BreakpointTrackerContext);
    const localeService = ServiceManager.getService('locale-service');


    const getBanner = useCallback((polCommonDetails) => {
        const url = _.get(env, 'DEPLOYMENT_URL');
        let lobBannerImage = getPageHeaderImage(pageName);
        if (breakpoint === 'phone' && localeService.getPolicyProvince() === 'NS') {
            lobBannerImage = 'Kings-Logo-HFM-Blue.png';
        } else if (lobCode) {
            lobBannerImage = getBannerImage(lobCode);
        }
        const bannerUrl = `${url}/branding/${lobBannerImage}`;
        return bannerUrl;
    }, [env]);

    const overrides = {
        bgPolicyTypeImage: {
            src: getBanner(pageName)
        },
        pageTitle: {
            content: pageTitle ? pageTitle : `Welcome ${_.capitalize(useAuthentication().given_name)}!`
        },
        dotsImage: {
            src: getImageSrc('branding/dots-hero.svg')
        }
    };



    const resolvers = {
        resolveClassNameMap: styles
    };



    return renderContentFromMetadata(metadata.componentContent, overrides, resolvers);
}

PageBannerComponent.propTypes = {
    //routes: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default withRouter(React.memo(PageBannerComponent));
